import { render } from "./assetstable.vue?vue&type=template&id=3f18a2d2&scoped=true"
import script from "./assetstable.vue?vue&type=script&lang=js"
export * from "./assetstable.vue?vue&type=script&lang=js"

import "./assetstable.vue?vue&type=style&index=0&id=3f18a2d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f18a2d2"]])

export default __exports__